import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

export interface SecondaryActionButton {
    disabled?: boolean;
    icon?: IconProp;
    label: string;
    tooltip?: string;
    type?: ButtonType;
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-filter-menu-skeleton',
    styleUrl: './filter-menu-skeleton.component.scss',
    templateUrl: './filter-menu-skeleton.component.html',
})
export class FilterMenuSkeletonComponent {
    public readonly secondaryActionButton = input<SecondaryActionButton | undefined>(undefined);
    public readonly secondaryActionDisabled = input(false);
    public readonly secondaryActionTooltip = input<string | undefined>(undefined);
    public secondaryButtonClicked = output<void>();
    public submit = output<void>();

    protected readonly ButtonType = ButtonType;
}
